import { Version } 			from './../../services/Version'
import { Creative } 			from './../../services/Creative'
import { AIAgent } 			from './../../services/AIAgent'

// Ограничения длины описания ошибки превью, отправляемого агенту
const PREVIEW_ERROR_MAX_MESSAGE_LENGTH = 1000;
const PREVIEW_ERROR_MAX_STACK_LENGTH = 3000;
// Сколько мс после переключения версии игнорируются ошибки фрейма превью
const PREVIEW_ERROR_SWITCH_BLOCK_TIME = 1000;
// Ошибки, вызванные прерванной загрузкой ресурсов (быстрое переключение версий, закрытие фрейма), - не ошибки кода креатива
const PREVIEW_ERROR_IGNORED_PATTERNS = [/NetworkError/i, /Failed to fetch/i, /Load failed/i, /Error in input stream/i, /Failed to load (video|script|image|audio|asset|resource)/i, /AbortError/i, /The operation was aborted/i];

// Примесь компонента AIAgent.vue: перехват ошибок фрейма превью и предложение отправить агенту запрос на их исправление
export default {
	data() {

		this.previewErrorsBlockedUntil = 0;

		return {
			// Первая ошибка текущей загрузки фрейма превью: {message, source, line, column, stack, creativeId, versionId, count}
			previewError: null,
			// Реагирование на ошибки во фрейме превью для выбранной версии включено (хранится в localStorage)
			previewErrorCatching: true
		};

	},
	methods: {
		// Пользователь переключил версию - сразу отключаем определение ошибок: старый фрейм выгружается и сыплет сетевыми ошибками (прерванные запросы)
		blockPreviewErrors() {

			this.previewErrorsBlockedUntil = Date.now() + PREVIEW_ERROR_SWITCH_BLOCK_TIME;

		},
		dismissPreviewError() {

			this.previewError = null;

		},
		// Читаем состояние для выбранной версии: по умолчанию ошибки перехватываются, в localStorage сохраняется только выключенное состояние
		restorePreviewErrorCatching() {

			let storageKey = this.getPreviewErrorCatchingStorageKey();

			this.previewErrorCatching = !storageKey || window.localStorage.getItem(storageKey) !== '0';

		},
		// Ключ localStorage состояния реагирования на ошибки фрейма для выбранной версии
		getPreviewErrorCatchingStorageKey() {

			return Version.SelectedVersion ? `ai-chat-preview-error-catching-${Version.SelectedVersion.id}` : null;

		},
		// Запоминаем первую ошибку загрузки фрейма (обычно она и есть причина остальных), последующие только считаем
		setPreviewError(error) {

			if (!error || !Creative.SelectedCreative || !Version.SelectedVersion || !this.previewErrorCatching) return;

			if (Date.now() < this.previewErrorsBlockedUntil) return;

			if (PREVIEW_ERROR_IGNORED_PATTERNS.some(pattern => pattern.test(String(error.message || '')))) return;

			if (this.previewError && this.previewError.creativeId === Creative.SelectedCreative.id && this.previewError.versionId === Version.SelectedVersion.id) {

				this.previewError = _.extend({}, this.previewError, {count: this.previewError.count + 1});

				return;

			}

			this.previewError = {
				message: String(error.message || 'Unknown error').substring(0, PREVIEW_ERROR_MAX_MESSAGE_LENGTH),
				source: String(error.source || ''),
				line: error.line || 0,
				column: error.column || 0,
				stack: String(error.stack || '').substring(0, PREVIEW_ERROR_MAX_STACK_LENGTH),
				creativeId: Creative.SelectedCreative.id,
				versionId: Version.SelectedVersion.id,
				count: 1
			};

			this.$nextTick(() => this.scrollHistoryToBottom());

		},
		// Предложение исправить ошибку показываем для выбранной версии
		isPreviewErrorShown() {

			return Boolean(this.previewError && this.previewError.creativeId === Creative.SelectedCreative?.id && this.previewError.versionId === Version.SelectedVersion?.id);

		},
		// Отправляем агенту запрос на исправление ошибки с её описанием и стеком вызовов
		askAgentToFixPreviewError() {

			let error = this.previewError;

			if (!error) return;

			let content = `The preview failed with an error. Please find the cause and fix it.\n\n` +
				`Error: ${AIAgent.getPreviewErrorDescription(error)}` +
				(error.count > 1 ? `\nTotal errors during the preview load: ${error.count}` : '') +
				(error.stack ? `\nStack trace:\n${error.stack}` : '');

			this.dismissPreviewError();

			this.sendUserMessage(content);

		},
		togglePreviewErrorCatching() {

			let storageKey = this.getPreviewErrorCatchingStorageKey();

			this.previewErrorCatching = !this.previewErrorCatching;

			if (storageKey) {

				if (this.previewErrorCatching) window.localStorage.removeItem(storageKey);
				else window.localStorage.setItem(storageKey, '0');

			}

			// При выключении убираем уже показанное предложение исправить ошибку
			if (!this.previewErrorCatching) this.dismissPreviewError();

		}
	}
}
